export default __webpack_public_path__ + "static/icon-full-autoML-default-33db0c02ee7d93e946fc9ccbe91a2e6b.svg";